export default "__VITE_ASSET__7e2a1ade__"